export default __webpack_public_path__ + "static/media/logo-gwu.5cbee1f0.svg";